// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__5q+Zb","title":"Timeline_title__SuR3w"};